import request from '@/config/axios'

// AI 视频 VO
export interface PptVO {
  id: number // 编号
  userId: number // 用户编号
  picUrl: string // 视频地址
  status: number // 音乐状态
  prompt: string // 提示词
  platform: string // 模型平台
  model: string // 模型
  publicStatus: boolean // 是否发布
  taskId: string // 任务id
  errorMessage: string // 错误信息
  createTime:Number // 创建时间
  categoryName:string // 分类名称
   options: {
    model: string
    ratio: string
    style: string
    prompt: string
    modelId: string
    options: string
    callback_url: string
  }
}

// AI 音乐 API
export const PptApi = {

  //详情
  getPptDetail: async (id: Number) => {
    return await request.get({ url: `/ai/ppt/get?id=${id}`})
  },

  // 分页
  getPptPage: async (params: any) => {
    return await request.get({ url: `/ai/ppt/page`, params })
  },

  // 更新
  updatePpt: async (data: any) => {
    return await request.put({ url: '/ai/ppt/update', data })
  },

  // 删除
  deletePpt: async (id: number) => {
    return await request.delete({ url: `/ai/ppt/delete?id=` + id })
  },

  // 发布审核
  auditsPublishPpt: async (data:{id:Number,publicStatus:Boolean}) => {
    return await request.post({ url: '/ai/ppt/audits-publish',data});
  },

  // 申请发布审核
  applyPublishPpt: async (data:{id:Number,applyPublish:Boolean}) => {
    return await request.post({ url: '/ai/ppt/apply-publish',data});
  },
  // 设置分类
     category: async (data :{id:number,categoryName:string}) => {
      return await request.post({ url: '/ai/ppt/category' ,data});
      },
  
}
